<template>
  <div class="content">
    <div v-show="loading || loadingsc" class="loading">
      <loading-panel></loading-panel>
    </div>
    <div
      class="background-image-search"
      style="background-image: url(/img/temp/blurred-dark.jpg"
    ></div>
    <!-- /.background-image-search -->

    <base-header class="header--recipe mb-6" type="none">
      <b-row align-v="center" class="py-4">
        <h1 v-show="!this.isEdit">Add Recipe</h1>
        <h1 v-show="this.isEdit">Edit Recipe</h1>
      </b-row>
    </base-header>
    <b-container
      class="container--md mt--6"
    >
      <div class="add-recipe__container">
        <a class="original-file" :href="`https://acxionspringboard.blob.core.windows.net/docs/${model.originalFile}`" target="_blank" v-if=" model.originalFile "><i class="far fa-file-excel"></i></a>
        <validation-observer v-slot="{handleSubmit}" ref="formValidator">
      <form class="needs-validation"
            @submit.prevent="handleSubmit(firstFormSubmit($event))">
        <div class="form-row">
          <b-col sm="7" md="3">
            <base-input label="Chef">
              <el-select v-model="model.chefId" filterable placeholder="Chef">
                <el-option
                  :key="null"
                  :label="'Select Chef'"
                  :value="null"
                />
                <el-option v-for="chef in chefs"
                            :key="chef.id"
                            :label="chef.fullNameLastFirst"
                            :value="chef.id">
                </el-option>
              </el-select>
            </base-input>
          </b-col>  
          <b-col id="subrecipe">       
            <label class="form-control-label">
              Subrecipe
            </label><br />
            <base-checkbox class="mb-3" v-model="model.isSubrecipe"></base-checkbox>
          </b-col>
        </div>
        <div class="form-row">
          <b-col sm="12" md="8">
            <base-input label="Recipe Name"
                        name="name"
                        type="textarea"
                        placeholder="Recipe Name"
                        success-message="Looks good!"
                        rules="required"
                        ref="recipeName"
                        v-model="model.name">
            </base-input>
          </b-col>

          <b-col sm="6" md="2">
            <base-input label="Job Code"
                        name="jobCode"
                        type="textarea"
                        placeholder="Job Code..."
                        v-model="model.jobCode">
            </base-input>
          </b-col>

          <b-col sm="6" md="2">
            <base-input label="Status">
              <label class="form-control-label" v-if="!isAdmin && model.statusCode == 'P'">
                Published
              </label>
              <el-select
                v-model="model.statusCode" 
                filterable
                placeholder="Status"
                v-if="!isAdmin && model.statusCode != 'P'"
              >
                <el-option v-for="option in userStatusOptions"
                            :key="option.id"
                            :label="option.name"
                            :value="option.id">
                </el-option>
              </el-select>
              <el-select
                v-model="model.statusCode" 
                filterable
                placeholder="Status"
                v-if="isAdmin"
              >
                <el-option v-for="option in adminStatusOptions"
                            :key="option.id"
                            :label="option.name"
                            :value="option.id">
                </el-option>
              </el-select>
            </base-input>
          </b-col>
          <!--b-col md="1">
            <label class="form-control-label">
              Featured
            </label><br />
            <base-switch label="Featured"
                    name="featured"
                    class="mr-1" 
                    on-text="Yes" 
                    off-text="No" 
                    v-model="model.featuredItem">
            </base-switch>
          </b-col-->

          <b-col md="12">
            <label class="form-control-label">
              Recipe Description
            </label>
            <html-editor
              v-model="model.description">
            </html-editor>
          </b-col>

          <b-col sm="12" md="6">
            <label class="form-control-label">
              Recipe Main image
            </label>
           
            <div class="dropzone-header">
               <div v-show="loadingMainImage" class="loading">
                <loading-panel></loading-panel>
              </div>
                <vue2Dropzone
                  v-on:vdropzone-file-added="fileAdded"
                  v-on:vdropzone-max-files-exceeded="maxFileExceeded"
                  id="mainImage"
                  :options="mainOptions"
                  v-show="!loadingMainImage"
                  ref="mainImage"
                />
             </div>
          </b-col>
          <b-col sm="12" md="6">
            <label class="form-control-label">
              Recipe Carousel Images
            </label>
            
           <div class="dropzone-images">
             <div v-show="loadingCarouselImages" class="loading">
              <loading-panel></loading-panel>
            </div>
                <vue2Dropzone
                  v-on:vdropzone-file-added="filesAdded"
                  v-on:vdropzone-max-files-exceeded="maxFilesExceeded"
                  v-on:vdropzone-duplicate-file="duplicateFile"
                  id="carouselImages"
                  :options="imagesOptions"
                  ref="carouselImages"
                  v-show="!loadingCarouselImages"
                />
            </div>
            <div class="image-previews">
            </div>
          </b-col>
        </div>
        <hr />
        <div class="form-row">
          <b-col sm="12" md="6">
           <base-input label="Operators">
              <el-select
                v-model="recipeOperators" 
                filterable
                multiple
                placeholder="Select Operators"
                @change="() => sortSelectedList(recipeOperators, operatorsOptions, 'name')"
              >
                <el-option v-for="option in operatorsOptions"
                            :key="option.id"
                            :label="option.name"
                            :value="option.id">
                </el-option>
              </el-select>
            </base-input>
          </b-col>
      
          <b-col sm="12" md="6">
           <base-input label="Brand">
              <el-select
                v-model="recipeBrands" 
                filterable
                multiple
                placeholder="Select Brands"
                @change="() => sortSelectedList(recipeBrands, brandOptions, 'name')"
              >
                <el-option v-for="option in brandOptions"
                            :key="option.id"
                            :label="option.name"
                            :value="option.id">
                </el-option>
              </el-select>
            </base-input>
          </b-col>

          <b-col sm="12" md="6">
           <base-input label="Collections">
              <el-select
                v-model="recipeCollections" 
                filterable
                multiple
                placeholder="Select Collections"
                @change="() => sortSelectedList(recipeCollections, collectionOptions, 'name')"
              >
                <el-option v-for="option in collectionOptions"
                            :key="option.id"
                            :label="option.name"
                            :value="option.id">
                </el-option>
              </el-select>
            </base-input>
          </b-col>

          <b-col sm="12" md="6">
           <base-input label="Contributors">
              <el-select
                v-model="recipeContributors" 
                filterable
                placeholder="Select Contributors"
                multiple
                @change="() => sortSelectedList(recipeContributors, contributorOptions, 'fullNameLastFirst')"
              >
                <el-option v-for="option in contributorOptions"
                            :key="option.id"
                            :label="option.fullNameLastFirst"
                            :value="option.id">
                </el-option>
              </el-select>
            </base-input>
          </b-col>

          <b-col sm="12" md="6" v-for="cat in tagCategories" :key="cat.id">
            <base-input :label="cat.name">
              <el-select
                  v-model="model.newTags[cat.id]" 
                  filterable
                  :placeholder="'Select ' + cat.name"
                  multiple
                  value-key="id"
                  @change="() => sortSelected(cat)"
              >
              <el-option
                v-for="option in (Array.isArray(cat.tags) ? cat.tags : Object.values(cat.tags || {}))
                  .filter(o => o && o.id != null)
                  .slice()
                  .sort((a, b) => (a.name || '').localeCompare(b.name || ''))"
                :key="option.id"
                :label="option.name || ''"
                :value="option.id"
              />
              </el-select>
            </base-input>
          </b-col>

          <b-col sm="6" md="3">
            <base-input label="Prep Time"
                        name="prepTime"
                        placeholder="Prep Time"
                        v-model="model.prepTime">
            </base-input>
          </b-col>
          <b-col sm="6" md="3">
            <base-input label="Cook Time"
                        name="cookTime"
                        placeholder="Cook Time"
                        v-model="model.cookTime">
            </base-input>
          </b-col>
          <b-col sm="6" md="3">
            <base-input label="Servings"
                        name="servings"
                        placeholder="Servings"
                        v-model="model.servings">
            </base-input>
          </b-col>

        </div>

        <!--
        <b-col md="12">
          <base-input name="IsScalable" Policy>
            <b-form-checkbox v-model="model.isScalable">
              <span class="text-muted"
                >Is Scalable?</span
              >
            </b-form-checkbox>
          </base-input>
        </b-col>
        -->
        
        <b-col md="12">
          <label class="form-control-label">Recipe Ingredients</label>
          <RecipeEditIngredients
            :ingredients="model.recipeIngredients"
          />
        </b-col>
        <b-col md="12">
          <InstructionsTable
            :instructions="model.instructions"
          />
        </b-col>
        <div class="form-row">
        <b-col sm="12" md="6">
          <label class="form-control-label">
            Additional Notes
          </label>
          <html-editor
            v-model="model.notes">
          </html-editor>
          <!--button
            class="btn base-button btn-secondary"
            v-on:click.prevent="showNotesUpload = true"
          >
            Add File To Notes
          </button>
           <div class="dropzone-area" v-if="showNotesUpload">
              <dropzone-file-upload
                v-model="model.notes"
                multiple
              />
           </div-->
        </b-col>

        <b-col sm="12" md="6">
            
            <label class="form-control-label">
              Recipe Links
            </label> 

            <b-card class="links-card">
              <b-list-group flush data-toggle="checklist" v-show="model.recipeLinks.length">
                <b-list-group-item class="checklist-entry flex-column align-items-start py-4 px-4"
                    v-for="(item, index) in model.recipeLinks"
                    :key="index"
                >
                <div class="checklist-item">
                  <div>
                    <a :href="item.uri" target="_blank">{{ item.name }}</a>
                    <p>{{ item.description }}</p>
                  </div>
                  <div style="width:20px">
                    <button type="button"
                            class="close"
                            @click="deleteLink(index, item)"
                            data-dismiss="modal"
                            aria-label="Delete">
                      <span>×</span>
                    </button>
                  </div>
                </div>
                </b-list-group-item>
              </b-list-group>
              <button
                class="btn base-button btn-secondary mt-3"
                v-on:click.prevent="addLinkHandler"
              >
                Add Link
              </button>
            </b-card>
          </b-col>
          <b-col sm="12" md="6">
            <label class="form-control-label">
              Recipe Attachments
            </label>
            
           <div class="dropzone-images">
             <div v-show="loadingAttachments" class="loading">
              <loading-panel></loading-panel>
            </div>
                <vue2Dropzone
                  v-on:vdropzone-file-added="attachmentsAdded"
                  v-on:vdropzone-max-files-exceeded="maxAttachmentsExceeded"
                  v-on:vdropzone-duplicate-file="duplicateAttachment"
                  id="attachments"
                  :options="attachmentOptions"
                  ref="attachments"
                  v-show="!loadingAttachments"
                />
            </div>
            <div class="attachment-previews">
            </div>
          </b-col>
        </div>
        <base-button v-show="loading || loadingsc" type="primary" native-type="button">Please Wait <i class="fas fa-spinner fa-spin"></i></base-button>
        <base-button v-show="!loading && !loadingsc" type="primary" name="save-continue" native-type="submit">Save</base-button>
        <base-button v-show="!loading && !loadingsc" type="primary" name="save" native-type="submit">Save &amp; Exit</base-button>
        <base-button
              type="secondary"
              native-type="button"
              @click="$router.go(-1)"
              >Cancel</base-button
            >
      </form>
    </validation-observer>
      </div>
    </b-container>
  </div>
</template>
<script>
  import { computed } from 'vue';
  import { Select, Option } from 'element-ui'
  import HtmlEditor from '../../components/Inputs/HtmlEditor.vue';
  import RecipeEditIngredients from '../Components/RecipeEditIngredients.vue';
  import InstructionsTable from '../Components/InstructionsTable';
  import { authHeader } from '../../_helpers';
  import slugify from 'slugify';
  import axios from 'axios'
  import swal from 'sweetalert2'
  import LoadingPanel from '../../components/LoadingPanel.vue';
  import vue2Dropzone from 'vue2-dropzone'

  const apiClient = axios.create({
    baseURL: `${process.env.VUE_APP_API_HOSTNAME}/api/`,
    withCredentials: false,
    headers: authHeader()
  })

  export default {
    name: "EditRecipe",
    components: {
        HtmlEditor,
        vue2Dropzone,
        [Select.name]: Select,
        [Option.name]: Option,
        RecipeEditIngredients,
        InstructionsTable,
        LoadingPanel
        },
    data() {
      return {
        validated: false,
        model: {
          id:'',
          languageCode:'',
          chefId:'',
          recipeBrands:[],
          name: '',
          jobCode: '',
          statusCode: 'I',
          statusName: '',
          slug: '',
          isSubrecipe: false,
          originalFile: '',
          description: '',
          mainImage: [],
          image: {},
          images: [],
          recipeImages: [],
          recipeAttachments: [],
          clientId: '',
          //brand: [],
          recipeContributors: [],
          tags: [],
          recipeTags: [],
          recipeLinks: [],
          dietaryTags: [],
          tempTags: [],
          recipeCollections: [],
          cookTime: '',
          prepTime: '',
          servings: '',
          recipeIngredients: [],
          recipeOperators: [],
          instructions: [],
          note: '',
          notes: '',
          altTags: [],
          newTags: []
        },
        mainImage: [],
        images: [],
        attachments: [],
        dietaryTags: [],
        recipeBrands: [],
        recipeIngredients: [],
        recipeContributors: [],
        recipeOperators: [],
        recipeCollections:[],
        recipeTags: [],
        loading: false,
        loadingsc: false,
        loadingMainImage: true,
        loadingCarouselImages: true,
        loadingAttachments: true,
        showNotesUpload: false,
        attachmentOptions: {
          url: 'https://as-uw-marlin-whipstir-api.azurewebsites.net/api/assets/uploadfile',
          uploadMultiple: true,
          thumbnailWidth: 50,
          thumbnailHeight: 50,
          previewsContainer: ".attachment-previews",
          maxFiles: 5,
          dictRemoveFile: '<i class="fas fa-trash-alt"></i>',
          duplicateCheck: true,
          autoProcessQueue: false,
          addRemoveLinks: true,
          headers: {'Authorization': 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IjNiNzFlNzZiLTc3Y2ItNDIxMy1hY2NmLTZkYzg3ZTIyMGJjNSIsImNvbXBhbnlpZCI6ImRjZDMzZDA3LTZkNzctNGZiOS04NmQ5LTBiOWNiNWE4ODE1OSIsImNsaWVudGlkIjoiMTFiZDc5NWYtMzFmYS00NmYyLWJjMzgtYmY1N2E1ZGU2YTFiIiwibmJmIjoxNjI0MDM0ODI5LCJleHAiOjE2MjQ2Mzk2MjksImlhdCI6MTYyNDAzNDgyOX0.Zuv_tqHUep9jCiTmbZDOUEnXHwHBvfeMbWlopwyw3gw'},
        },
        imagesOptions: {
          url: 'https://as-uw-marlin-whipstir-api.azurewebsites.net/api/assets/uploadfile',
          uploadMultiple: true,
          thumbnailWidth: 50,
          thumbnailHeight: 50,
          previewsContainer: ".image-previews",
          maxFiles: 5,
          dictRemoveFile: '<i class="fas fa-trash-alt"></i>',
          duplicateCheck: true,
          autoProcessQueue: false,
          addRemoveLinks: true,
          headers: {'Authorization': 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IjNiNzFlNzZiLTc3Y2ItNDIxMy1hY2NmLTZkYzg3ZTIyMGJjNSIsImNvbXBhbnlpZCI6ImRjZDMzZDA3LTZkNzctNGZiOS04NmQ5LTBiOWNiNWE4ODE1OSIsImNsaWVudGlkIjoiMTFiZDc5NWYtMzFmYS00NmYyLWJjMzgtYmY1N2E1ZGU2YTFiIiwibmJmIjoxNjI0MDM0ODI5LCJleHAiOjE2MjQ2Mzk2MjksImlhdCI6MTYyNDAzNDgyOX0.Zuv_tqHUep9jCiTmbZDOUEnXHwHBvfeMbWlopwyw3gw'},
        },
        mainOptions: {
          url: 'https://as-uw-marlin-whipstir-api.azurewebsites.net/api/assets/uploadfile',
          uploadMultiple: false,
          thumbnailWidth: 450,
          thumbnailHeight: 200,
          //previewsContainer: ".dropzone-previews",
          maxFiles: 1,
          autoProcessQueue: false,
          addRemoveLinks: true,
          headers: {'Authorization': 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IjNiNzFlNzZiLTc3Y2ItNDIxMy1hY2NmLTZkYzg3ZTIyMGJjNSIsImNvbXBhbnlpZCI6ImRjZDMzZDA3LTZkNzctNGZiOS04NmQ5LTBiOWNiNWE4ODE1OSIsImNsaWVudGlkIjoiMTFiZDc5NWYtMzFmYS00NmYyLWJjMzgtYmY1N2E1ZGU2YTFiIiwibmJmIjoxNjI0MDM0ODI5LCJleHAiOjE2MjQ2Mzk2MjksImlhdCI6MTYyNDAzNDgyOX0.Zuv_tqHUep9jCiTmbZDOUEnXHwHBvfeMbWlopwyw3gw'},
        },
        adminStatusOptions: [
          {
            'id': 'I',
            'name': 'Incomplete'
          },
          {
            'id': 'C',
            'name': 'Complete'
          },
          {
            'id': 'P',
            'name': 'Published'
          }
        ],
        userStatusOptions: [
          {
            'id': 'I',
            'name': 'Incomplete'
          },
          {
            'id': 'C',
            'name': 'Complete'
          }
        ],
        isEdit: false,
        submitType: 'save'
      }
    },
    computed: {
        contributorOptions() {
          return this.$store.state.users.selectList
        },
        tagOptions() {
          return this.$store.state.tags.nonDietarySelectList
        },
        dietaryOptions() {
          return this.$store.state.tags.dietarySelectList
        },
        collectionOptions(){
          return this.$store.state.collections.selectList
        },
        brandOptions() {
          let brands = this.$store.state.brands.selectList
          if (brands.length < 1) {
            return this.tempBrands
          } else {
            return this.$store.state.brands.selectList
          }
        },
        operatorsOptions() {
          return this.$store.state.operators.selectList
        },
        isAdmin() {
          return this.$store.getters.userIsAdmin
        },
        isLoading() {
          return this.$store.state.recipes.loading
        },
        isLoadingSC() {
          return this.$store.state.recipes.loadingsc
        },
        tagCategories() {
          return this.$store.state.taggroups.selectList
        },
        users() {
          return this.$store.state.users.selectList
        },
        chefs() {
            return Array.isArray(this.users) ? this.users.filter(user => user.securityLevel === 5) : [];
        }
    },
    created() {
        //this.$store.dispatch('authentication/resetRecipeState', {}, {root:true})
        this.$store.dispatch('taggroups/getSelectList');
        this.$store.dispatch('brands/getSelectList');
        this.$store.dispatch('collections/getSelectList');
        this.$store.dispatch('units/getSelectList');
        this.$store.dispatch('operators/getSelectList');
        this.$store.dispatch('ingredients/clearSavedIngredients')
        this.$store.dispatch('instructions/clearSavedInstructions')
        this.$store.dispatch("ingredients/getIngredients",{
          "query": '',
          "filter": 'I'
        });
        this.$store.dispatch("users/getSelectList");

        if (this.$route.query.lang) {
          this.lang = this.$route.query.lang;
        }else{
          this.lang = 'en';
        }

        if(this.$route.params.id){
          this.isEdit = true;
          this.model.id = this.$route.params.id;
          this.getRecipe(this.model.id);
        }else{
          if(this.$store.state.authentication.user.user.securityLevel === 5){
            //this.model.chefId = this.$store.state.authentication.user.user.id;
          }
          this.isEdit = false;
          this.createRecipe();
        }
    },
    methods: {
      loadCurrentImages() {
        if (this.model.image) {
          var mockFile = { name: this.model.image.name, size: 50000, type: 'image', id: this.model.image.id};
          this.$refs.mainImage.manuallyAddFile(mockFile, this.model.image.absoluteUri);
        }
        for (const img in this.model.recipeImages) {
          var mockFile = { name: this.model.recipeImages[img].image.name, size: 50000, type: 'image', id: this.model.recipeImages[img].id};
          this.$refs.carouselImages.manuallyAddFile(mockFile, this.model.recipeImages[img].image.absoluteUri);
        }
        for (const att in this.model.recipeAttachments) {
          var mockFile = { name: this.model.recipeAttachments[att].attachment.name, size: 50000, type: 'image', id: this.model.recipeAttachments[att].id};
          this.$refs.attachments.manuallyAddFile(mockFile, this.model.recipeAttachments[att].attachment.absoluteUri);
        }
      },
      sortSelected(cat) {

        const selectedIds = this.model.newTags[cat.id];

        if (!Array.isArray(selectedIds)) return;

        if (!Array.isArray(cat.tags)) return;


        // Map selected IDs to full tag objects
        const selectedTags = cat.tags.filter(tag => selectedIds.includes(tag.id));

        // Sort by tag name
        const sortedTags = [...selectedTags].sort((a, b) => a.name.localeCompare(b.name));

        // Extract sorted IDs
        const sortedIds = sortedTags.map(tag => tag.id);

        // Only update if order has changed
        const isSameOrder = selectedIds.length === sortedIds.length &&
          selectedIds.every((id, idx) => id === sortedIds[idx]);

        if (!isSameOrder) {
          this.$set(this.model.newTags, cat.id, sortedIds);
        }
      },
      sortSelectedList(selectedIds, optionsList, labelKey) {

        if (!selectedIds || !optionsList) return;

        // If you're passing a wrapper like { loading: true, items: [...] }
        if (optionsList.loading) return;

        // Clone to avoid mutating original list
        const selectedItems = selectedIds
          .map(id => optionsList.find(opt => opt.id === id))
          .filter(Boolean); // Ignore any not found

        // Sort selected items alphabetically by the label field
        selectedItems.sort(function (a, b) {
          var labelA = (a[labelKey] && a[labelKey].toLowerCase()) || '';
          var labelB = (b[labelKey] && b[labelKey].toLowerCase()) || '';
          return labelA.localeCompare(labelB);
        });

        // Update selectedIds in the new order
        const sortedIds = selectedItems.map(item => item.id);
        selectedIds.splice(0, selectedIds.length, ...sortedIds);
      },
      maxFileExceeded(file) {
        this.$refs.mainImage.removeAllFiles()
        this.$refs.mainImage.addFile(file)
        this.mainImage = []
        this.mainImage.push(file)
      },
      duplicateFile(file) {
        //Not working ???
        this.$refs.carouselImages.removeFile(file)
        this.images.pop();
      },
      maxFilesExceeded(file) {
        this.$refs.carouselImages.removeFile(file)
        this.images.pop();
        swal.fire({
          title: `Only ${this.imagesOptions.maxFiles} images allowed`,
          text: '',
          type: 'warning',
          showCancelButton: false,
          confirmButtonClass: 'btn btn-success btn-fill',
          confirmButtonText: 'Close',
          buttonsStyling: false,
        })
      },
      fileAdded(file) {
        if(file.size > 9000000){
          this.$refs.mainImage.removeFile(file);
          swal.fire({
            title: `Images must be under 9MB to be attached to a recipe`,
            text: '',
            type: 'warning',
            showCancelButton: false,
            confirmButtonClass: 'btn btn-success btn-fill',
            confirmButtonText: 'Close',
            buttonsStyling: false,
          })
        }else{
          this.mainImage = []
          this.mainImage.push(file)
        }
      },
      filesAdded(file) {
        if(file.size > 9000000){
          this.$refs.carouselImages.removeFile(file);
          swal.fire({
            title: `Images must be under 9MB to be attached to a recipe`,
            text: '',
            type: 'warning',
            showCancelButton: false,
            confirmButtonClass: 'btn btn-success btn-fill',
            confirmButtonText: 'Close',
            buttonsStyling: false,
          })
        }else{
          this.images.push(file)
        }
      },
      attachmentsAdded(file) {
        if(file.size > 9000000){
          this.$refs.attachments.removeFile(file);
          swal.fire({
            title: `Attachments must be under 9MB to be attached to a recipe`,
            text: '',
            type: 'warning',
            showCancelButton: false,
            confirmButtonClass: 'btn btn-success btn-fill',
            confirmButtonText: 'Close',
            buttonsStyling: false,
          })
        }else{
          this.attachments.push(file)
        }
      },
      maxAttachmentsExceeded(file) {
        this.$refs.attachments.removeFile(file)
        this.attachments.pop();
        swal.fire({
          title: `Only ${this.attachmentOptions.maxFiles} attachments allowed`,
          text: '',
          type: 'warning',
          showCancelButton: false,
          confirmButtonClass: 'btn btn-success btn-fill',
          confirmButtonText: 'Close',
          buttonsStyling: false,
        })
      },
      duplicateAttachment(file) {
        //Not working ???
        this.$refs.attachments.removeFile(file)
        this.attachments.pop();
      },
      addLinkHandler(event) {
        swal.fire({
        title: 'Add Link',
        html:
        '<div class="form-row swal-form">'+
        '<label class="form-control-label">Link Title</label>' +
        '<input id="linkTitle" class="form-control" placeholder="Title" >' +
        '<label class="form-control-label">Link Url</label>' +
        '<input id="linkUri" class="form-control" placeholder="https://youtube.com/owie8wke">' +
        '<label class="form-control-label">Link Desription</label>' +
        '<textarea id="linkDescription" class="form-control" rows="2"></textarea>' +
        '</div>',
        focusConfirm: false,
        confirmButtonClass: 'btn btn-info btn-fill',
        showCancelButton: true,
        preConfirm: () => {
          const linkObject = { 
            "name":document.getElementById('linkTitle').value,
            "description":document.getElementById('linkDescription').value,
            "uri":document.getElementById('linkUri').value
            }
          return linkObject;
        }
      }).then((result) => {
        if (result.value) {
          this.model.recipeLinks.push(result.value);
        }
      });
      },
      deleteLink(index, item) {
        swal.fire({
          title: 'Delete Link?',
          text: item.name,
          type: 'warning',
          showCancelButton: true,
          confirmButtonClass: 'btn btn-success btn-fill',
          cancelButtonClass: 'btn btn-danger btn-fill',
          confirmButtonText: 'Delete',
          buttonsStyling: false,
        }).then((result) => {
          if (result.value) {
            this.model.recipeLinks.splice(index, 1);
          }
        });
      },
      async firstFormSubmit(e) {
        const { dispatch } = this.$store;

        this.submitType = e.submitter.name;
        this.loadingsc = this.submitType == "save-continue";

        const sendData = this.model;
        delete sendData.user;

        sendData.instructions = this.$store.state.instructions.saved;
        sendData.recipeIngredients = this.$store.state.ingredients.saved;
        sendData.recipeTags = [];
        sendData.recipeBrands = [];
        sendData.recipeCollections = [];
        sendData.recipeOperators = [];
        sendData.recipeContributors = [];

        for (const property in this.model.newTags) {
          for(const t in this.model.newTags[property]){
            sendData.recipeTags.push({'tagId': this.model.newTags[property][t]});
          }
        }
        
        for (const property in this.recipeBrands) {
          sendData.recipeBrands.push({'brandId':this.recipeBrands[property]});
        }
        for (const property in this.recipeCollections) {
          sendData.recipeCollections.push({'collectionId':this.recipeCollections[property]});
        }
        for (const property in this.recipeOperators) {
          sendData.recipeOperators.push({'operatorId':this.recipeOperators[property]});
        }
        for (const property in this.recipeContributors) {
          sendData.recipeContributors.push({'userId':this.recipeContributors[property]});
        }

        for (const ctr in sendData.recipeIngredients) {
          if(sendData.recipeIngredients[ctr].ingredient){
            sendData.recipeIngredients[ctr].ingredientId = sendData.recipeIngredients[ctr].ingredient.id;
            delete sendData.recipeIngredients[ctr].ingredient;
          }
          if(sendData.recipeIngredients[ctr].subRecipe) {
            sendData.recipeIngredients[ctr].subRecipeId = sendData.recipeIngredients[ctr].subRecipe.id;
            delete sendData.recipeIngredients[ctr].subRecipe;
          }
        }
        for (const property in sendData.instructions) {
                delete sendData.instructions[property].step;
        }
        sendData.attachments = Object.values(this.$refs.attachments.dropzone.files);
        sendData.images = Object.values(this.$refs.carouselImages.dropzone.files);
        sendData.mainImage = this.$refs.mainImage.dropzone.files[0];
        delete sendData.recipeImages;
        delete sendData.image;
        delete sendData.recipeAttachments;

        if (this.model.name) {
          try {
              if(this.model.id){
                await dispatch("recipes/updateRecipe", sendData)
                    .then(response => {
                      if(this.$store.state.recipes.update.error){
                       swal.fire({
                          title: `An error has occurred. Please try again.`,
                          text: '',
                          type: 'warning',
                          showCancelButton: false,
                          confirmButtonClass: 'btn btn-success btn-fill',
                          confirmButtonText: 'Close',
                          buttonsStyling: false,
                        });
                        console.log('Something went wrong: recipe edit ', error);
                      }
                      this.getRecipe(this.$store.state.recipes.current.id).then(response => { });   
                }).catch(error => {
                });
              }else{
                delete sendData.id;
                delete sendData.clientId;

                sendData.languageCode = 1;
                await dispatch("recipes/addRecipe", sendData)
                    .then(response => {
                        if(this.$store.state.recipes.update.error){
                          swal.fire({
                            title: this.errorMessage(this.$store.state.recipes.update.error),
                            text: '',
                            type: 'warning',
                            showCancelButton: false,
                            confirmButtonClass: 'btn btn-success btn-fill',
                            confirmButtonText: 'Close',
                            buttonsStyling: false,
                          });
                          console.log('Something went wrong: recipe add ', error);
                        }
                        this.model.id = this.$store.state.recipes.current.id;
                        this.getRecipe(this.$store.state.recipes.current.id).then(response => {
                      });                      
                }).catch(error => {
                });
              }

          } catch (error) {
              console.log("Error: recipe edit", error);
          }
        }

        this.loadingsc = false;
      },
      errorMessage(m) {
        var msg = 'An Unexpected Error Has Occurred';
        switch (m) {
          case "Conflict":
            msg = 'Recipe Name Already Exists';
        }
        return msg;
      },
      addCollectionRow() {
        this.model.collections.push({ id: '' })
      },
      createRecipe() {
        this.loadingMainImage = false;
        this.loadingCarouselImages = false;
        this.loadingAttachments = false;
      },
      async getRecipe(id) {
        const currentRecipe = await apiClient.get(`recipes/${id}?lang=${this.lang}`).then(response => {
            this.$store.state.recipes.current = response.data;

                if (!response.data.slug) {
                    response.data.slug = slugify(response.data.name);
                }
                for (const property in response.data) {
                    if (this.model[property] || this.model[property] == '') {
                        this.model[property] = response.data[property];
                    }
                }
                for (const property in this.model.instructions) {
                    this.model.instructions[property].step =  this.model.instructions[property].sortOrder;
                }
                for (const property in this.model.recipeIngredients) {
                    this.model.recipeIngredients[property].position =  this.model.recipeIngredients[property].sortOrder;
                }
                for (const property in response.data.recipeBrands) {
                  this.recipeBrands.push(response.data.recipeBrands[property].brandId);
                }
                for (const property in response.data.recipeCollections) {
                  this.recipeCollections.push(response.data.recipeCollections[property].collectionId);
                }

                for (const property in response.data.recipeContributors) {
                  this.recipeContributors.push(response.data.recipeContributors[property].userId);
                }
                for (const property in response.data.recipeOperators) {
                  this.recipeOperators.push(response.data.recipeOperators[property].operatorId);
                }

                this.sortSelectedList(this.recipeOperators, this.operatorsOptions, 'name');
                this.sortSelectedList(this.recipeBrands, this.brandOptions, 'name');
                this.sortSelectedList(this.recipeCollections, this.collectionOptions, 'name');
                this.sortSelectedList(this.recipeContributors, this.contributorOptions, 'fullNameLastFirst');

                for(var cat in this.tagCategories){
                  this.model.newTags[this.tagCategories[cat].id] = [];
                }

                for (const property in response.data.recipeTags) {
                  if(this.model.newTags[response.data.recipeTags[property].tag.tagGroupId]){
                    this.model.newTags[response.data.recipeTags[property].tag.tagGroupId].push(response.data.recipeTags[property].tagId);
                  }
                }

                // Now that we've added initial values, sort them alphabetically
                for(var cat in this.tagCategories){
                  this.sortSelected(this.tagCategories[cat]);
                }

                const { dispatch } = this.$store;
                dispatch("instructions/setSavedInstructions", this.model.instructions);
                dispatch("ingredients/setSavedIngredients", this.model.recipeIngredients);

                setTimeout(() => {
                  this.loadCurrentImages();
                    this.loadingMainImage = false;
                    this.loadingCarouselImages = false;
                    this.loadingAttachments = false;
                  }, 800);
        });
      },
      async getTag(id) {
          return await apiClient.get(`tags/${id}`);
      }
    },
      watch: {
        isLoading (newLoad, oldLoad) {
          if (newLoad == 'Saved') {
            this.loading = false;
            if(this.submitType == "save"){
              this.$router.push({ name: 'Recipe', params: { id: this.model.id ? this.model.id : this.$store.state.recipes.current.id } });
            }
            this.$notify({verticalAlign: 'top', horizontalAlign: 'right', type: 'success', message: 'Recipe Updated'});
          }else{
            this.loading = newLoad
          }
        },
        isLoadingSC (newLoad, oldLoad) {
          if (newLoad == 'Saved') {
            this.loadingsc = false;
            if(this.submitType == "save"){
              this.$router.push({path: `/recipe/${this.model.id ? this.model.id : this.$store.state.recipes.current.id}`});
            }
            this.$notify({verticalAlign: 'top', horizontalAlign: 'right', type: 'success', message: 'Recipe Updated'});
          }else{
            this.loadingsc = newLoad
          }
        }
      }
  }
</script>
<style>
  #subrecipe {
    text-align:right;
  }
.shortcut-item.add-collection{
  text-align: left;
  margin-bottom: 30px;
}
.edit-img {
  width: 100%;
}
.delete-main-img {
  position: absolute;
  top: 10px;
  right: 10px;
}
.recipe-images-list {
  border: 0;
}
.avatar {
  overflow: hidden;
}
.original-file {
    float:right;
    margin: -20px 0 0 10px;
    z-index: 99999;
}
</style>